/***
 * if the URl include a querystring "webcomponentsdebug=true" (?webcomponentsdebug=true or &webcomponentsdebug=true)
 * this function returns true, it could use to write console.log-debug statements.
 * At the same time a session storage variable "webcomponentsdebug" is set to debug over several pages
 *
 * ?webcomponentsdebug=false or &webcomponentsdebug=false turn off the debug.
 *
 * Tipp: add javascript:window.location.href=window.location.href+'?webcomponentsdebug=true' as bookmark;
 *
 * @return true | false
 */

const queryString = window.location.search; // ?webcomponentsdebug=true
const urlParams = new URLSearchParams(queryString);
let webComponentsDebugQuery;

try {
  webComponentsDebugQuery = JSON.parse(urlParams.get("webcomponentsdebug")); //convert to boolean
} catch (e) {
  console.log("Error:", e);
  webComponentsDebugQuery = false;
}

let debugMode: boolean;
debugMode = false;

function webComponentsDebug() {
  if (webComponentsDebugQuery && typeof webComponentsDebugQuery === "boolean") {
    sessionStorage.setItem("webcomponentsdebug", "true");
  } else if (!webComponentsDebugQuery && typeof webComponentsDebugQuery === "boolean") {
    sessionStorage.removeItem("webcomponentsdebug");
  }
  if (sessionStorage.getItem("webcomponentsdebug")) {
    debugMode = true;
  }
  return debugMode;
}
export default webComponentsDebug();
